module.exports = __webpack_public_path__ + "static/media/soundwave.cef825ef.gif";